export default __webpack_public_path__ + "static/pro-petroleum-d7417819a9528ee02eae6e27ceac9015.png";